import { Component } from '@angular/core';
import { HttpClient} from '@angular/common/http';
import { environment } from 'environments/environment';
import { AuthService } from '../../_services';
import { ActivatedRoute, Router } from '@angular/router';
import { LoaderService } from '../../_services/loader.service'; 
import * as _moment from 'moment';
import * as _rollupMoment from 'moment';
const moment = _rollupMoment || _moment;
import Swal from 'sweetalert2'
import { utils, write, WorkBook } from 'xlsx';  
import { saveAs } from 'file-saver'; 
declare var $: any; 
@Component({
  templateUrl: './secondaryReport.component.html',
})

export class  secondaryReportComponent{
  address:any
  public prjId: any
  public userId: any
  public startDate: any
  public endDate: any
  public defaultStartDate: any
  public defaultEndDate: any
  public dataRangeModal: any
  public showLoader: boolean
  public data :any;

  currentDateModal:any;
  defStartDt:any;
  defEndDt:any;
  dateRange:any;
  geocoder:any;
  latLngDataList:any;
  VCdate: any;
  vehicleTypeSelect: { id: any; name: string; }[];
  reportType: { id: string; name: string; }[];
  vehicleTypeSelectModal: any;
  reportTypeModal: any;
  selectFillterData: any;
  constructor(private http : HttpClient , private auth: AuthService, public routes: ActivatedRoute, public router: Router, private loaderService: LoaderService) {
    this.loaderService.status.subscribe((val: boolean) => {
      this.showLoader = val;
    }); 
    var date = new Date();   
    this.currentDateModal=date;
    this.defStartDt = (date.getFullYear()) + '-' + (date.getMonth() + 1) + '-' + date.getDate(); 
    this.defEndDt = (date.getFullYear()) + '-' + (date.getMonth()+1) + '-' + date.getDate(); 
    this.dateRange= {beginDate: {year: date.getFullYear(), month: date.getMonth()+1, day: date.getDate()},endDate: {year: date.getFullYear(), month: date.getMonth()+1, day: date.getDate()}}; 
    }

    

   
 
 
  orgValueChange(date){  
    this.VCdate = date
    this.startDate = moment( this.VCdate ).format('YYYY-MM-DD'); 
   
  }



  importVehicleStopReport(data){
   const ws_name = 'vehicleRunningReport';
   const wb: WorkBook = { SheetNames: [], Sheets: {} };
   const ws: any = utils.json_to_sheet(data);
   wb.SheetNames.push(ws_name);
   wb.Sheets[ws_name] = ws;
   const wbout = write(wb, { bookType: 'xlsx', bookSST: true, type: 'binary' });
   saveAs(new Blob([this.s2ab(wbout)], { type: 'application/octet-stream' }), 'vehicleRunningReport.xlsx');
   }s2ab(s){
       const buf = new ArrayBuffer(s.length);
       const view = new Uint8Array(buf);
       for (let i = 0; i !== s.length; ++i) {
       view[i] = s.charCodeAt(i) & 0xFF;
       };
       return buf;
   }  
    

  
 

    ngOnInit() {
      this.prjId = this.auth.getAuthentication().projectId
      this.userId = this.auth.getAuthentication().id
      this.startDate = moment(this.defaultStartDate).format('YYYY-MM-DD'); 
      this.geocoder = new google.maps.Geocoder; 

      this.vehicleTypeSelect = [
        { id:2,name:'Hyva'},
        { id:5,name:'Tipper'},
        { id:6,name:'Tractor'},
        { id:7,name:'Dumper Truck'},
        { id:11,name:'Hook Loader'},
        { id:12,name:'JCB 2DX'},
        { id:13,name:'JCB 3DX'},
        { id:15,name:'Refuse Compactor'},
        { id:16,name:'SCAVANGING VAN'},
        { id:18,name:'TATA MOTERS HCV'},
        { id:20,name:'DOZER'},
        { id:21,name:'DP'},
        { id:28,name:'Bolero Secondary'},
      ];

       this.reportType = [
        { id: 'One', name: 'Fule Consumption' },
        { id: 'Two', name: 'Vehicle Distance Report' },
        { id: 'Two', name: 'Working Time' },
        
       ];


       this.getSecondaryJCBVehicleDetails()
  }







  reloadComponent() {
    let currentUrl = this.router.url;
        this.router.routeReuseStrategy.shouldReuseRoute = () => false;
        this.router.onSameUrlNavigation = 'reload';
        this.router.navigate([currentUrl]);


      
    }


  // Filter Data details

  // let startDate = moment(this.defaultStartDate).format('YYYY-MM-DD');
  // let endDate = moment(this.defaultEndDate).format('YYYY-MM-DD');

  //public startDate: any
  // public endDate: any


  onDateRangeChanged(dateRange) {


    if (dateRange.beginDate.day > 0) {
      this.defaultStartDate = dateRange.beginDate.year + "-" + dateRange.beginDate.month + "-" + dateRange.beginDate.day
      this.defaultEndDate = dateRange.endDate.year + "-" + dateRange.endDate.month + "-" + dateRange.endDate.day
      console.log('133',this.defaultStartDate, this.defaultEndDate);
      
      // this.getTopPerformer()
    } else if (dateRange.beginDate.day == 0) {
      this.defaultStartDate = this.defaultStartDate
      this.defaultEndDate = this.defaultEndDate
      console.log('139',this.defaultStartDate, this.defaultEndDate);
      
      // this.getTopPerformer()
    }
  }



  downloadreport(){

           var startDate = moment(this.defaultStartDate).format('YYYY-MM-DD');
          let endDate = moment(this.defaultEndDate).format('YYYY-MM-DD');

 

    this.vehicleTypeSelect

    console.log('171',this.vehicleTypeSelectModal,this.reportTypeModal,startDate,endDate);


    
    
  }


  getReport(){

  //   var startDate = moment(this.defaultStartDate).format('YYYY-MM-DD');
  //   let endDate = moment(this.defaultEndDate).format('YYYY-MM-DD');


  //  this.loaderService.display(true);
  //   this.http.get(environment.apiUrl + 'maintenance/getReport?prjid=' + this.prjId+'&startDate='+startDate+'&endDate='+endDate+"&vehicleTypeSelectModal="+this.vehicleTypeSelectModal+'&reportTypeModal='+this.reportTypeModal).subscribe((data) => {
      
      
  //   });

  }


  fillterDataSecondary(){

     

    console.log('198',this.vehicleTypeSelectModal);
    

    this.http.get(environment.apiUrl + 'maintenance/fillterDataSecondary?prjid=' + this.prjId+"&vehicleTypeSelectModal="+this.vehicleTypeSelectModal).subscribe((data) => {
      
       console.log('203',data)

        this.selectFillterData = data


    });

  }

  
  getSecondaryJCBVehicleDetails(){

     


    

    this.http.get(environment.apiUrl + 'reports/getSecondaryJCBVehicleDetails?prjid=' + this.prjId).subscribe((data) => {
      
         console.log('223',data);
          
         this.selectFillterData = data


    });

  }


  DownloadRunningdetails(IMEI){

    var startDate = moment(this.defaultStartDate).format('YYYY-MM-DD');
    var  endDate = moment(this.defaultEndDate).format('YYYY-MM-DD');



    this.loaderService.display(true);
    this.http.get(environment.apiUrl + 'reports/getSecondaryJCBVehicleRunningDetails?prjid=' + this.prjId+'&startDate='+startDate+'&endDate='+endDate+"&IMEI="+IMEI).subscribe((data) => {
      
          console.log('246',data);

          this.importVehicleStopReport(data)
          
        this.loaderService.display(false);
          
    });

    
  }


}


// WEBPACK FOOTER //
// ./src/app/reports/vtsReport/secondaryReport.component.ts